export const indonesiaOnlineTerms = (
  <>
    <h4>
      Sebelum melanjutkan, harap membaca dan menyetujui syarat & ketentuan
      berikut untuk Peserta Online:
    </h4>

    <ul>
      <li>
        Peserta yang tidak mengumpulkan berkas persyaratan (Full Paper) sampai
        batas waktu yang telah ditentukan, maka tidak akan mendapatkan nilai
        berkas dan hanya akan mendapatkan nilai pada saat sesi live judging
        saja.
      </li>
      <li>
        Peserta wajib menggunakan judul dan berkas persyaratan (Full Paper) yang sesuai dengan
        kategori yang diikuti. (Peserta internasional, wajib menggunakan bahasa
        Inggris untuk seluruh persyaratan dokumen yang dibutuhkan)
      </li>
      <li>
        Keputusan panitia terkait hal ini bersifat final dan tidak dapat
        diganggu gugat.
      </li>
    </ul>
    <p className="text-align">
      Selain itu, kami informasikan bahwa setiap event akan kami daftarkan ke
      kurasi SIM T Puspresnas.
    </p>
    <p className="text-align">
      Namun, hasil kurasi sepenuhnya merupakan wewenang Puspresnas dan tidak
      dapat diganggu gugat oleh pihak manapun. Oleh sebab itu, kami tidak
      menerima sanggahan maupun komplain terkait hasil kurasi yang telah
      ditetapkan oleh Puspresnas.
    </p>
  </>
);

export const indonesiaOfflineTerms = (
  <>
    <h5>
      Sebelum melanjutkan, harap membaca dan menyetujui syarat & ketentuan
      berikut untuk Peserta Offline:
    </h5>
    <ul>
      <li>
        Peserta yang tidak mengumpulkan berkas persyaratan (Full Paper) sampai
        batas waktu yang telah ditentukan, maka tidak akan mendapatkan nilai
        berkas dan hanya akan mendapatkan nilai pada saat sesi live judging
        saja.
      </li>
      <li>
        Peserta wajib menggunakan judul dan full paper yang sesuai dengan
        kategori yang diikuti. (untuk peserta yang mengikuti event tingkat
        internasional, wajib menggunakan bahasa Inggris untuk seluruh
        requirement)
      </li>
      <li>
        Peserta diwajibkan untuk membuat poster berukuran A0, membawa produk dan
        poster tersebut pada saat sesi penjurian.
      </li>
      <li>
        Pemberian penghargaan kepada peserta akan dilakukan sesuai dengan urutan
        yang telah ditetapkan dalam susunan acara (peserta tidak diperkenankan
        untuk meminta award sebelum gilirannya).
      </li>
      <li>
        Peserta diwajibkan untuk mengikuti seluruh rangkaian kegiatan sesuai
        dengan jadwal yang telah disusun oleh panitia penyelenggara.
      </li>
      <li>
        Bagi peserta offline yang berhak atas hadiah Best booth, Best Poster,
        Best Presentation, Best Project, uang tunai, semi grand award, dan grand
        award namun tidak dapat hadir pada acara penyerahan hadiah, maka hadiah
        yang bersangkutan dinyatakan hangus.
      </li>
      <li>
        Keputusan panitia terkait hal ini bersifat final dan tidak dapat
        diganggu gugat.
      </li>
    </ul>
    <p className="text-align">
      Selain itu, kami informasikan bahwa setiap event akan kami daftarkan ke
      kurasi SIM T Puspresnas.
    </p>
    <p className="text-align">
      Namun, hasil kurasi sepenuhnya merupakan wewenang Puspresnas dan tidak
      dapat diganggu gugat oleh pihak manapun. Oleh sebab itu, kami tidak
      menerima sanggahan maupun komplain terkait hasil kurasi yang telah
      ditetapkan oleh Puspresnas.
    </p>
  </>
);
